<template lang="pug">
validation-observer(ref='observer' tag='form')
  div
    el-row
      divider(label="Confirmar publicação no Diário Oficial")

    el-row
      div#pdf(v-if="bytes")
        app-pdf-viewer(:bytes="bytes")

    el-row
      validation-provider(rules="required", v-slot="{ errors }", name="Publicação no diário oficial")
        app-label.upload-margin(label="Upload da Publicação no Diário Oficial", :required="true")
        app-upload-area(
          id="diarioOficial"
          :target="urlUpload"
          :fileType="validExtensions"
          :onSuccess="onSuccess"
          :documento="despacho.documento"
          v-model="despacho.documento"
          @download="download"
          @removerDocumento="removerDocumento"
          :errors="errors"
        )

    el-row
      div.container
        app-radios-tramitacao(
          v-if="radiosAcoes.length && processo.status !== 'AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL'",
          :radios="radiosAcoes",
          :isDecisao="true",
          :radioInicial="radioInicial",
          @changeRadio="changeRadio"
        )

    el-row
      div#btn
        app-buttons-cadastro(
          :showButtonDownload="true",
          :showButtonCancelar="false",
          :isUltimoPasso="true"
          finalizarLabel="Finalizar",
          downloadLabel="Download PDF",
          @download="download",
          @voltar="goToListagem",
          @finalizar="finalizar"
        )
</template>

<script>
import { mapActions } from 'vuex'
import AppPDFViewer from '@/components/AppPDFViewer'
import AppLabel from '@/components/AppLabel'
import Divider from '@/screens/arrecadacao/components/Divider'
import AppUploadArea from '@/components/AppUploadArea'
import FileHelper from '@/utils/fileHelper'
import cloneDeep from 'lodash/cloneDeep'
import BaseAnaliseProcessos from '@/screens/arrecadacao/mixins/BaseAnaliseProcessos'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppPdfViewer: AppPDFViewer,
    AppLabel,
    Divider,
    AppUploadArea,
    FileHelper,
    AppRadiosTramitacao,
    AppButtonsCadastro
  },

  props: {
    processo: { required: true, type: Object },
    radiosAcoes: { required: true, type: Array },
    routeListagemName: { required: true, type: String }
  },

  mixins: [BaseAnaliseProcessos, AppNotificacao],

  data () {
    return {
      radio: null,
      bytes: null,
      validExtensions: ['pdf'],
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      documento: null
    }
  },

  methods: {
    ...mapActions({
      getPDFPortaria: 'portariaArrecadacao/getPDFPortariaAssinado',
      tramitarComAcao: 'processoArrecadacao/tramitarComAcao',
      downloadDocumentos: 'documentoArrecadacao/download',
      finalizarDiarioOficial: 'processoArrecadacao/finalizarDiarioOficial'
    }),

    async renderPDF (idPortaria) {
      const bytes = await this.getPDFPortaria(idPortaria)
      this.bytes = bytes
    },

    onSuccess (id, resumableFile, fileKey) {
      const documento = this.despacho.documento

      this.despacho.documento = {
        id: documento ? documento.id : null,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false
      }

      this.$emit('atualizarDiarioOficial', this.despacho.documento)
    },

    async download (id) {
      const documento = this.despacho.documento

      const arrayBuffer = await this.downloadDocumentos({
        fileKey: documento.fileKey,
        id: documento.id
      })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    removerDocumento (id) {
      let documento = cloneDeep(this.despacho.documento)

      if (documento.id) {
        documento.removed = true
      } else {
        documento = null
      }

      this.despacho.documento = documento
    },
    async finalizar () {
      if (this.processo.status === 'AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL') {
        this.despacho.acao = 'AGUARDANDO_MINUTA_MATRICULA.ADM_S1.GP'
      }
      const valido = await this.$refs.observer.validate()
      if (valido) {
        this.confirmBox(
          'Deseja confirmar esta ação?',
          this.$messages.TITULO_WARNING,
          async () => {
            this.finalizarDiarioOficial(this.despacho)
              .then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.$messages.SUCESSO_CONFIRMAR_PUBLICACAO
                )
                this.goToListagem()
              })
              .catch(error => {
                this.showNotificacao(
                  this.$messages.TIPO_WARNING,
                  this.$messages.TITULO_WARNING,
                  error.message
                )
              })
          },
          () => {},
          'Sim',
          'Não'
        )
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    }
  },

  mounted () {
    const { idPortaria, idProcesso } = this.$route.query
    this.renderPDF(idPortaria)
    this.despacho = {
      ...this.despacho,
      processoId: idProcesso,
      texto: 'Diário Oficial publicado',
      tipoDespacho: 'PUBLICACAO_DIARIO_OFICIAL'
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.container-input {
  margin-right: 20px;
}

.button {
  margin-top: 55px;
}

.container-pdf {
  padding-top: 20px;
  width: 100%;
}

#pdf >>> .card-info {
  margin: 0%;
}

>>> .el-radio__label {
  font-size: 16px;
}
>>> .el-radio.erro-teste {
  border: 2px firebrick solid;
}

.upload-margin {
  margin-top: 1rem;
  margin-bottom: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/diarioOficial/InformarPublicacao.vue